import React from 'react';
import PropTypes from 'prop-types';
import { Form, Radio } from 'antd';
import i18next from 'i18next';
import { translate } from 'react-i18next';
import moment from 'moment';
import { get } from 'lodash';
import PerfectScrollbar from 'react-perfect-scrollbar';

import SelectField from 'Parts/ui/components/fields/SelectField';
import NumberField from 'Parts/ui/components/fields/NumberField';
import FundkyButton from 'Parts/ui/components/FundkyButton';
import { moneyFormat } from 'Parts/common/moneyFormat';

import { CAMPAIGN_TEMPLATE_SOLO } from '../../../../../campaign/campaignUtils';

import ChooseTicketsForm_en from './locales/ChooseTicketsForm_en.json';
import ChooseTicketsForm_fr from './locales/ChooseTicketsForm_fr.json';

import { setTicketSelectionAmount } from './../../../../../donation/components/ticketAmount';

import './ChooseTicketsForm.less';

class ChooseTicketsForm extends React.Component {
  constructor(props) {
    super(props);

    // Clear previous selection
    props.clearTicketsSelection();

    // Import tickets
    props.fetchTicketList(props.campaign.id, { showDescription: true });

    // Check if there is decimal to a price
    let round = true;
    if(get(props, 'tickets.results.length', 0) > 0) {
      let tickets = get(props, 'tickets.results', []);
      round = tickets.filter(ticket => !Number.isInteger(Number(ticket.totalPrice))).length
        ? false
        : true
    }

    this.state = {
      totalQuantity: 0,
      totalPrice: 0,
      isLoading: false,
      round: round,
      isLoggedIn: props.userTypeId === 2,
      lastAction: null,
      limitReached: (props.eventTicketLimit && props.sold) &&
        props.sold >= props.eventTicketLimit
    };

    i18next.addResourceBundle('en', 'ChooseTicketsForm', ChooseTicketsForm_en);
    i18next.addResourceBundle('fr', 'ChooseTicketsForm', ChooseTicketsForm_fr);
  }

  componentDidUpdate(prevProps, prevState) {
    const _self = this;
    // Check if there is decimal to a price
    if (get(this.props, 'tickets.results.length', 0) !== get(prevProps, 'tickets.results.length', 0)) {
      let round = true;
      if(get(this.props, 'tickets.results.length', 0) > 0) {
        let tickets = get(this.props, 'tickets.results', []);
        round = tickets.filter(ticket => !Number.isInteger(Number(ticket.totalPrice))).length
          ? false
          : true
      }
      if (this.state.round != round) {
        this.setState({
          round: round
        });
      }
    }

    if (prevProps.userTypeId !== this.props.userTypeId && (this.props.userTypeId === 2) !== this.state.isLoggedIn) {
      this.setState({
        isLoggedIn: this.props.userTypeId === 2
      });

      if (this.state.lastAction === 'submit') {
        setTimeout(function() {
          if (!get(_self.props, 'campaign.participating')) {
            _self.submitChoice();
          } else {
            _self.props.hideModal();
          }
        }, 1000);
      }
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ isLoading: true });
    if (this.state.isLoggedIn) {
      this.submitChoice();
    } else {
      const customAlert = {
        title: this.props.t('notification-not-logged-in-title'),
        description: this.props.t('notification-not-logged-in-description')
      };
      this.setState({ lastAction: 'submit' });
      this.props.openLoginModal(false, customAlert);
    }
  };

  submitChoice = () => {
    // The force option is required because we have dynamic rules
    // See https://github.com/react-component/form/issues/130
    this.props.form.validateFields({ force: true }, (err, values) => {
      if (!err) {
        const reserved = {tickets: []};
        const tickets = [];
        let id, quantity, ticket, price, reserve;

        let totalAmount = 0;
        for (const field in values) {
          if (field.indexOf('quantity_') > -1) {
            quantity = parseInt(values[field]) > 0 ? parseInt(values[field]) : 0;
            if (quantity > 0) {
              id = field.split('quantity_').join('');
              ticket = this.props.tickets.results
              .filter(_value => _value.id == id)
              .map(_value => ({
                ticket: _value,
                quantity: quantity,
                totalPrice: Number(_value.totalPrice) * quantity
              }))[0];
              totalAmount += ticket.totalPrice;
              tickets.push(ticket);
              reserve = this.props.tickets.results
              .filter(_value => _value.id == id)
              .map(_value => ({
                ticketId: _value.id,
                quantity: quantity
              }))[0];
              reserved.tickets.push(reserve);
            }
          }
        }
        setTicketSelectionAmount(totalAmount);
        
        if (tickets.length) {
          this.props.createTicketReserve(this.props.campaign.id, reserved)
            .then(response => {
              if(response && !response.error) {
                const formValues = {campaign: this.props.campaign, team: this.props.team, tickets: tickets};
                this.props.saveTicketsSelection(formValues);
                this.props.history.push(`/${this.props.locale}/${this.props.campaign.alias}/${this.props.t('URL:ticket-purchase/details')}`);
              }
              this.setState({ isLoading: false });
              return response;
            });
        } else {
          this.setState({ isLoading: false });
        }

      } else {
        this.setState({ isLoading: false });
      }
    });
  };

  generateLimitOptions = limit => {
    let options = [];

    for (let i = 0; i <= limit; i++) {
      options.push({ value: i, text: i.toString() });
    }

    return options;
  };

  updateSummary = (value, fieldId) => {
    let newValue =
      isNaN(value) || value === '' || value === null || value < 0 ? 0 : parseInt(value);

    const values = this.props.form.getFieldsValue();
    let totalQuantity = 0;
    let totalPrice = 0;

    let id, quantity, price;
    for (const field in values) {
      if (field.indexOf('quantity_') > -1) {
        quantity =
          field === fieldId ? newValue : parseInt(values[field]) > 0 ? parseInt(values[field]) : 0;
        id = field.split('quantity_').join('');
        price = this.props.tickets.results
          .filter(_value => _value.id == id)
          .map(_value => _value.totalPrice)[0];
        totalQuantity += parseInt(quantity);
        totalPrice += Number(price) * parseInt(quantity);
      }
    }

    this.setState({
      totalQuantity: totalQuantity,
      totalPrice: totalPrice,
      limitReached: (this.props.eventTicketLimit && (this.props.sold || this.props.sold === 0)) &&
      this.props.sold + totalQuantity > parseInt(this.props.eventTicketLimit)
    });
  };

  // New function for Radio Button
  // updateSummary2 = (ticketId) => {
  //   let totalPrice = 0;

  //   if (ticketId && get(this.props, 'tickets.results.length')) {
  //     totalPrice = this.props.tickets.results.filter(ticket => ticket.id === ticketId).map(ticket => ticket.totalPrice)[0] || 0;
  //     totalPrice = Number(totalPrice);
  //   }

  //   this.setState({
  //     totalQuantity: ticketId ? 1 : 0,
  //     totalPrice: totalPrice,
  //     limitReached: (this.props.eventTicketLimit && (this.props.sold || this.props.sold === 0)) &&
  //     this.props.sold + (ticketId ? 1 : 0) > parseInt(this.props.eventTicketLimit)
  //   });
  // };

  render() {
    const { props, handleSubmit, generateLimitOptions } = this,
      { t, form, locale, tickets, available, campaign } = props,
      { getFieldDecorator } = form;
    const campaignTypeId = get(campaign, 'typeId');

    const ticketsArray = get(tickets, 'results', []).map((ticket, index) => {
      const options = generateLimitOptions(Number(get(ticket, 'limitPerTransaction', 0)));
      const disabled = get(ticket, 'available', 0) == 0;
      const field = get(ticket, 'limitPerTransaction') && get(ticket, 'limitPerTransaction') <= 10
          ? <SelectField
              className="Ticket--quantity"
              form={form}
              fieldId={'quantity_' + ticket.id}
              optionsArray={options}
              initialValue={0}
              overModal
              onChange={value => this.updateSummary(value, 'quantity_' + ticket.id)}
              disabled={disabled}
            />
          : <NumberField
              className="Ticket--quantity"
              form={form}
              fieldId={'quantity_' + ticket.id}
              initialValue={0}
              fieldOptions={{
                rules: [
                  {
                    validator: (rule, value, callback) => {
                      let _value = isNaN(value) || value === '' || value === null || value < 0 ? 0 : parseInt(value);
                      this.props.form.setFieldsValue({["quantity_" + ticket.id]: _value});
                      return _value >= 0
                        ? callback()
                        : callback(true);
                    },
                    message: t('quantity-min', { count: 0 })
                  },
                  {
                    validator: (rule, value, callback) => {
                      let _value =
                        isNaN(value) || value === '' || value === null || value < 0
                          ? 0
                          : parseInt(value);
                      this.props.form.setFieldsValue({
                        ['quantity_' + ticket.id]: _value
                      });
                      return _value <= get(ticket, 'available', 0)
                        ? callback()
                        : callback(true);
                    },
                    message: t('quantity-max', { count: get(ticket, 'available', 0) })
                  }
                ]
              }}
              formatter={value => value.toString().replaceAll(/[^\d]/g, '')}
              onChange={value => this.updateSummary(value, 'quantity_' + ticket.id)}
              disabled={disabled}
            />;

      return (
        <div
          className={"Ticket t" + index + "-" + ticket.id + " " + (disabled ? "disabled" : '')}
          key={index + '-' + ticket.id}
          onClick={() => {
            // if (campaignTypeId !== CAMPAIGN_TEMPLATE_SOLO && !disabled) {
            //   let tickets = document.querySelectorAll('.Ticket');
            //   tickets.forEach(_ticket => {
            //     if (_ticket.classList.contains('selected')) {
            //       _ticket.classList.remove("selected");
            //     }
            //   });
            //   let _ticket = document.querySelector('.Ticket.t'+ index + "-" + ticket.id);
            //   if (!_ticket.classList.contains('selected')) {
            //     _ticket.classList.add('selected');
            //   }
            //   form.setFieldsValue({"selectedTicket": ticket.id});
            //   this.updateSummary2(ticket.id);
            // }
          }}
        >
          <h2>{get(ticket, 'description.name', '')}</h2>
          {ticket.forceParticipation &&
            <p>{t('participation-warning-part1')}<a href={t('participation-warning-url')} target="_blank" rel="noopener noreferrer">{t('participation-warning-part2')}</a>{t('participation-warning-part3')}</p>
            || null
          }
          <div className="Ticket--upperInfo">
            <p>{get(ticket, 'description.description', '')}</p>
            <div className="Ticket--priceQuantity">
              <span className="Ticket--price">
                {moneyFormat(get(ticket, 'totalPrice', 0), locale, this.state.round)}
              </span>
              {field}
            </div>
          </div>
          <div className="Ticket--subInfo">
            <div className="Ticket--limits">
              {get(ticket, 'limitPerTransaction') && (
                <span>
                  {t('limited', { count: get(ticket, 'limitPerTransaction', 0) })}
                </span>
              )}
              <span>
                {
                  get(ticket, 'endOn') &&
                  t('ends', { date: moment(get(ticket, 'endOn')).format('LL') }) ||
                  t('noends')
                }
              </span>
            </div>
            {get(ticket, 'available', 0) === 0
              ? <div className="Ticket--available">
                  {t('sold-out')}
                </div>
              : get(ticket, 'displayAvailability')
                ? <div className="Ticket--available">
                    {t(
                      'available',
                      {
                        count: get(ticket, 'available', 0) < available
                          ? get(ticket, 'available', 0)
                          : available
                      }
                    )}
                  </div>
                : null
            }
          </div>
        </div>
      );
    });

    const ticketsList = /*campaignTypeId !== CAMPAIGN_TEMPLATE_SOLO
      ? getFieldDecorator("selectedTicket")(
          <Radio.Group>
            {ticketsArray}
          </Radio.Group>
        )
      :*/ ticketsArray;

    return (
      <Form className="ChooseTicketsForm" onSubmit={handleSubmit}>
        <div className="ChooseTicketsForm__TicketList">
          {this.props.eventTicketLimit &&
            <p className={this.state.limitReached && "limitReached" || ""}>{t('campaign-ticket-remaining', {count: this.props.eventTicketLimit - this.props.sold})}</p>
          }
          <PerfectScrollbar suppressScrollX={true} swipeEasing={true}>
            <Form.Item>
              {ticketsList}
            </Form.Item>
          </PerfectScrollbar>
        </div>
        <div className="ChooseTicketsForm__Bottom">
          {/* <div className="ChooseTicketsForm__CTA">
            <FundkyButton
              className="ChooseTicketsForm__PromoCode"
              text={t('promotional-code')}
              type="text"
              icon={['fal', 'tag']}
              iconPosition="before"
            />
          </div> */}
          <div className="ChooseTicketsForm__Footer">
            <div className="ChooseTicketsForm__Summary">
              <h3>{t('summary')}</h3>
              <div>
                <span>{t('ticket', { count: this.state.totalQuantity })}</span>
                <span>{moneyFormat(this.state.totalPrice, locale, this.state.round, 'CAD')}</span>
              </div>
            </div>
            <FundkyButton
              className="ChooseTicketsForm__Submit"
              text={t('checkout')}
              type="primary"
              onClick={e => this.handleSubmit(e)}
              loading={this.state.isLoading}
              disabled={this.state.limitReached || this.state.totalPrice > 10000}
            />
          </div>
          {this.state.totalPrice > 10000 &&
            <span className="error">{t('max-transaction-reached')}</span>}
        </div>
      </Form>
    );
  }
}

ChooseTicketsForm.propTypes = {
  form: PropTypes.object.isRequired
};

export default translate('ChooseTicketsForm')(ChooseTicketsForm);
